"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useApplyQueryParamsForStrategyMatrix = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../__generated__/graphql");
const react_redux_1 = require("react-redux");
const use_strategy_matrix_query_params_sync_1 = require("./use-strategy-matrix-query-params-sync");
const product_tree_node_1 = require("../../client/product-tree-node");
const use_get_enriched_categories_hook_1 = require("../../client/product-tree-nodes/hooks/use-get-enriched-categories.hook");
const selected_l1_categories_1 = require("../../store/shared/selected-l1-categories");
const hooks_1 = require("../client/hooks");
const store_1 = require("../store");
const store_2 = require("../../../store");
const areSelectedCategoriesEqual = (current, next) => (current.length === next.length
    && current.every((category, index) => {
        var _a, _b;
        const nextCategory = next[index];
        const currentChildren = (_a = category.children) !== null && _a !== void 0 ? _a : [];
        const nextChildren = (_b = nextCategory === null || nextCategory === void 0 ? void 0 : nextCategory.children) !== null && _b !== void 0 ? _b : [];
        return category.id === (nextCategory === null || nextCategory === void 0 ? void 0 : nextCategory.id)
            && currentChildren.length === nextChildren.length
            && currentChildren.every((childId, childIndex) => childId === nextChildren[childIndex]);
    }));
const useApplyQueryParamsForStrategyMatrix = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const selectedCatalogId = (0, store_2.useSelectedCatalogId)();
    const { extendedFilter = [], } = (0, store_1.useStrategyMatrixData)();
    const { data: enrichedSelectedL1Categories, } = (0, use_get_enriched_categories_hook_1.useGetEnrichedCategories)(extendedFilter);
    const { isHydrated: isViewStateHydrated, setTerminalNodeIdFromUrl, terminalNodeIdFromUrl, } = (0, use_strategy_matrix_query_params_sync_1.useStrategyMatrixQueryParamsSync)();
    const nodeRelationsSort = (0, react_1.useMemo)(() => [{ distance: graphql_1.SortOrder.Asc }], []);
    const { currentNode, data: ancestors, isTerminal, isLoading, error, } = (0, hooks_1.useGetNodeRelations)({
        productTreeNodeId: terminalNodeIdFromUrl,
        sort: nodeRelationsSort,
    });
    const selectedCategoriesFromUrl = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        if (!terminalNodeIdFromUrl || !ancestors.length)
            return undefined;
        let newSelectedCategories = [...enrichedSelectedL1Categories];
        const relatedL1Node = (_b = (_a = ancestors[product_tree_node_1.L1_NODE_ANCESTOR_NUMBER]) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.ancestor;
        if (!relatedL1Node)
            return undefined;
        const { id, title } = relatedL1Node;
        const existingCategory = newSelectedCategories.find((item) => item.value === id);
        newSelectedCategories = newSelectedCategories.filter((item) => item.value !== id);
        const newChildren = (_d = (_c = existingCategory === null || existingCategory === void 0 ? void 0 : existingCategory.children) === null || _c === void 0 ? void 0 : _c.filter(({ value }) => value !== currentNode.id)) !== null && _d !== void 0 ? _d : [];
        const selectedCategory = {
            label: title,
            value: id,
            children: [
                ...isTerminal ? [{
                        label: currentNode.title,
                        value: currentNode.id,
                    }] : [],
                ...newChildren
            ],
        };
        return [selectedCategory, ...newSelectedCategories];
    }, [ancestors, currentNode, enrichedSelectedL1Categories, isTerminal, terminalNodeIdFromUrl]);
    const extendedFilterFromUrl = (0, react_1.useMemo)(() => selectedCategoriesFromUrl === null || selectedCategoriesFromUrl === void 0 ? void 0 : selectedCategoriesFromUrl.map(selected_l1_categories_1.convertGroupedOptionToCategory), [selectedCategoriesFromUrl]);
    const isTerminalNodeFromUrlApplied = !terminalNodeIdFromUrl
        || (!!extendedFilterFromUrl && areSelectedCategoriesEqual(extendedFilter, extendedFilterFromUrl));
    (0, react_1.useEffect)(() => {
        if (selectedCatalogId && terminalNodeIdFromUrl && extendedFilterFromUrl) {
            if (areSelectedCategoriesEqual(extendedFilter, extendedFilterFromUrl)) {
                setTerminalNodeIdFromUrl(undefined);
                return;
            }
            dispatch((0, store_1.setSelectedDataForStrategyMatrix)(selectedCatalogId, { extendedFilter: extendedFilterFromUrl }));
        }
        if (terminalNodeIdFromUrl && !isLoading && error) {
            setTerminalNodeIdFromUrl(undefined);
        }
    }, [
        extendedFilter,
        extendedFilterFromUrl,
        selectedCatalogId,
        dispatch,
        error,
        isLoading,
        setTerminalNodeIdFromUrl,
        terminalNodeIdFromUrl,
    ]);
    return {
        isLoading,
        isReady: isViewStateHydrated && isTerminalNodeFromUrlApplied,
        error,
    };
};
exports.useApplyQueryParamsForStrategyMatrix = useApplyQueryParamsForStrategyMatrix;
